import React from 'react';
import classNames from 'classnames';
import { Typography } from 'antd';
import { Plan } from 'types';

import { isPlanActive } from './planStatus';
import cn from './PlanStatusBadge.module.scss';

type PlanStatusBadgeVariant = 'info' | 'onGradient';

type PlanStatusBadgeProps = {
  plan: Plan;
  /** `info` for light surfaces; `onGradient` for the blue gradient header. */
  variant?: PlanStatusBadgeVariant;
  'data-testid'?: string;
};

export function PlanStatusBadge({
  plan,
  variant = 'info',
  'data-testid': testId,
}: PlanStatusBadgeProps) {
  return (
    <Typography.Text className={classNames(cn.badge, cn[variant])} data-testid={testId}>
      <span className={cn.dot} />
      {isPlanActive(plan) ? 'Active' : 'Draft'}
    </Typography.Text>
  );
}
